export default function isAdmin (role) {
  const adminRoles = ['admin', 'superuser'];
  return adminRoles.includes(role);
}
